
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AxiosData } from "@/common/http/http";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import { Util, getPageAPIs } from "@/common/util";
import PoolCategoryAPI from "@/common/api/operationManage/poolCategory";

import {
  getCommonList
} from "@/common/config"

export const pageApiList = getPageAPIs(PoolCategoryAPI);


// 分类类型  1台球  2棋牌  3熊猫大明星（ktv）
const categoryShopType2Ch: string[] = ['', '熊猫球社', '熊猫国粹馆', '熊猫大明星']

const defaultForm: any = { 
  shop_type: 1
}

const defaultForms: any = {
  name: "",
  sort: "",
  shop_type: ''
}

@Component({})
export default class MerchantsAudit extends Vue {
  private poolCategoryApi: any;
  private title: string = "";
  private is_show: boolean = false;

  private categoryShopTypeList: any[] = [
    ...getCommonList(categoryShopType2Ch, 1)
  ]

  private deepLoopUtil: any;

  private form: any


  constructor() {
    super();
    this.deepLoopUtil = new DeepLoop();

    this.poolCategoryApi = new PoolCategoryAPI();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false)
    }

    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false)
    }
  }

  private forms: any = {
   
    // time: [],
  };
  private addtype(): void {
   this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false)
    }
    this.title = "新增";
    this.is_show = true;
  }

  private editortype(row: any) {
    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
      ...(row || {}),
    }
    this.title = "编辑";
    this.is_show = true;
  }

  private deletetype(id: string) {
    this.poolCategoryApi.deletetype(
      {
        id: id,
      },
      () => {
        this.is_show = false;
        Util.showToast("删除成功");
        this.search();
      }
    );
  }
  private submit(): void {
    if (this.title == "新增") {
      this.poolCategoryApi.addtype(this.forms, () => {
        this.is_show = false;
        Util.showToast("新增成功");
        this.search();
      });
    } else {
      this.poolCategoryApi.editortype(this.forms, () => {
        this.is_show = false;
        Util.showToast("修改成功");
        this.search();
      });
    }
  }
  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private activated(): void {
    this.search();
  }

  private getTable(): void {
    const form = this.form

    const {
      shop_type
    } = form

    const params: any = {}

    if (shop_type) {
      params.shop_type = shop_type
    }
    this.poolCategoryApi.poolTableCategory(
      {
        ...params,
        page: this.tablePage.pageNo,
        limit: this.tablePage.pageSize,
      },
      (res: any) => {
        this.tableData = res.data.list;
        this.tablePage.totalCount = res.data.count;
      }
    );
  }

  // private restForms(): void {
  //   this.forms = {
  //     ...this.deepLoopUtil.deepCopy(defaultForms, false)
  //   }

  //   this.getTable();
  // }


  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false)
    }

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
